import { AbstractView } from 'src/app/core/abstract_view';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
    selector: 'app-product-menu',
    templateUrl: './product-menu.component.html',
})
export class ProductMenuComponent extends AbstractView implements OnInit {
    public model: any[] = [];

    constructor(public messageService: MessageService, public router: Router) {
        super(messageService, router);
    }
    ngOnInit() {
        if (this.getAuth(['MANAGE_IMAGE_PRODUCT'])) {
            this.model.push({
                label: 'Catálogo de Productos',
                icon: '',
                routerLink: ['/products/manage-products'],
            });
        }
        if (this.getAuth(['MANAGE_ECOVALOR_PRODUCT'])) {
            this.model.push({
                label: 'Productos Ecovalor',
                icon: '',
                routerLink: ['/products/manage-ecovalor'],
            });
        }

        if (this.getAuth(['MANAGE_ECOVALOR_PRODUCT'])) {
            this.model.push({
                label: 'Código Auxiliar',
                icon: '',
                routerLink: ['/products/manage-auxiliary'],
            });
        }
    }

}
